import React from 'react';
import { IoClose } from 'react-icons/io5';
import { FaCheck } from 'react-icons/fa6';
import s from './style.css';
import { colors } from '../../foundations';
function findBackgroundColor(item) {
    switch (item) {
        case 'no':
            return 'rgba(255,0,0,0.1)';
        case 'yes':
            return 'rgba(0,255,0,0.1)';
        case 'limited':
        case 'external':
            return 'rgba(255,192,0,0.1)';
        case '$8.99':
            return 'rgba(96,96,255,0.1)';
        default:
            return 'rgba(0,0,0,0.1)';
    }
}
const Table = () => {
    const isDesktop = window.innerWidth > window.innerHeight;
    const tableData = [
        ['', 'Dropbox', 'iCloud', 'G-Drive', 'Sticknet'],
        ['End-to-end encrypted', 'no', 'limited', 'no', 'yes'],
        ['Decentralized storage', 'no', 'no', 'no', 'yes'],
        ['Integrated social network', 'no', 'no', 'no', 'yes'],
        ['Integrated messenger', 'no', 'external', 'no', 'yes'],
        ['2 TB cost / month', '$11.99', '$10.99', '$9.99', '$8.99'],
    ];
    return (React.createElement("table", { border: 1 },
        React.createElement("thead", null,
            React.createElement("tr", null, tableData[0].map((header, index) => (React.createElement("th", { key: index, style: {
                    textAlign: 'center',
                    color: header === 'Sticknet' ? colors.primary : '#000',
                    fontFamily: header === 'Sticknet' ? 'Sirin Stencil' : undefined,
                    fontSize: header === 'Sticknet' ? (isDesktop ? '1.2vw' : '5vw') : isDesktop ? '1vw' : '4.5vw',
                } }, header))))),
        React.createElement("tbody", null, tableData.slice(1).map((row, rowIndex) => (React.createElement("tr", { key: rowIndex },
            React.createElement("th", null, row[0]),
            row.slice(1).map((cell, cellIndex) => (React.createElement("td", { key: cellIndex },
                React.createElement("div", { className: s.cell, style: { backgroundColor: findBackgroundColor(cell) } }, cell === 'no' ? (React.createElement(IoClose, { color: 'red', size: 20 })) : cell === 'yes' ? (React.createElement(FaCheck, { color: colors.success, size: 20 })) : (React.createElement("span", { style: {
                        color: cell === 'external' || cell === 'limited'
                            ? 'rgb(255,128,0)'
                            : cell === '$8.99'
                                ? 'rgba(96,96,255)'
                                : 'grey',
                    } }, cell))))))))))));
};
export default Table;
